import { Select, SelectItem } from "client/Components";
import { Theme } from "client/Api/Branding/UserTheme/userTheme";
import { localize } from "client_legacy/ndaw/culture";
import { ReactElement } from "react";

export type ThemeSelectProps = {
	value: Theme;
	onChange(newTheme: Theme): void;
	menuTitle: string;
	trackingId: string;
};

export const ThemeSelect = (props: ThemeSelectProps): ReactElement => {
	const {
		value,
		onChange,
		menuTitle,
		trackingId
	} = props;

	return (
		<Select
			value={value}
			onChange={onChange}
			options={selectOptions}
			trackingId={trackingId}
			menuTitle={menuTitle}
		/>
	);
};
ThemeSelect.displayName = "ThemeSelect";

const selectOptions: SelectItem<Theme>[] = [
	{
		value: Theme.Light,
		text: localize("_ThemeLight")
	},
	{
		value: Theme.Dark,
		text: localize("_ThemeDark")
	},
	{
		value: Theme.System,
		text: localize("_ThemeSystem")
	}
];